"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConfig = void 0;
const _1 = require(".");
const DisplayDictionary_1 = require("./DisplayDictionary");
const Theme_1 = require("./Theme");
const Util_1 = require("./Util");
const pMap = {
    customer_code: (str) => typeof str === 'string',
    context_map: Util_1.isStringDict,
    index: (str) => typeof str === 'string',
    css: (str) => typeof str === 'string',
    template: (val) => (0, _1.isTemplate)(val),
    theme: Theme_1.isTheme,
    // disabling for now because this is too restrictive for our
    // pmc configs
    params: () => true,
    // params: isParams,
    display_dictionary: DisplayDictionary_1.isDisplayDictionary,
    validTypeaheadCategories: () => true,
    add_ons: () => true
};
const isConfig = (dict) => {
    return Object.entries(dict).every(([pKey, d]) => pMap[pKey] && pMap[pKey](d));
};
exports.isConfig = isConfig;
//# sourceMappingURL=Config.js.map